module.exports = __webpack_public_path__ + "img/lens-174-minus-01.e4667ce3.png";